// extracted by mini-css-extract-plugin
export default {"map":"oyTCm","mobile-map":"W5uMa","mobileMap":"W5uMa"};